<template>
	<div class="viewer">
		<div class="viewer-mask"></div>
		<span class="viewer-btn-close viewer-btn" @click="close()">
			<i class="el-icon-circle-close"></i>
		</span>
		<span class="viewer-btn-prev viewer-btn" @click="prev()">
			<i class="el-icon-arrow-left"></i>
		</span>
		<span class="viewer-btn-next viewer-btn" @click="next()">
			<i class="el-icon-arrow-right"></i>
		</span>
		<div class="viewer-btn-operation viewer-btn">
			<div class="viewer-btn-inner">
				<i class="el-icon-zoom-out" @click="scaleOut"></i>
				<i class="el-icon-zoom-in" @click="scaleIn"></i>
				<span class="total">{{ num + 1 }}/{{ imageList.length }}</span>
				<i class="el-icon-refresh-left" @click="leftRotate"></i>
				<i class="el-icon-refresh-right" @click="rightRotate"></i>
			</div>
		</div>
		<div class="viewer-canvas">
			<img class="viewer-image" :style="style" :src="imageUrl" @mousedown="move" alt="">
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return{
			// 图片列表
			imageList: [],
			// 图片下标
			num: 0,
			// 当前展示图片url
			imageUrl: "",
			style: 'transform: scale(1) rotate(0deg);',
			rotate: 0,
			scale: 1,
		}
	},
	methods:{
		// 初始化
		init(num,dt) {
			this.$nextTick(() =>{
				this.imageList = dt;
				this.num = num;
				this.imageUrl = this.imageList[this.num];
			})
		},
		// 关闭弹窗回调
		close() {
			this.$emit("closeViewer");
		},
		// 上一张
		prev() {
			if(this.num != 0){
				this.scale = 1;
				this.rotate = 0;
				this.style = 'transform: scale('+ this.scale +') rotate('+this.rotate+'deg);top:0px;left:0px;';
				this.num--;
				this.imageUrl = this.imageList[this.num];
			}
		},
		// 下一张
		next() {
			if(this.num != (this.imageList.length - 1)){
				this.scale = 1;
				this.rotate = 0;
				this.style = 'transform: scale('+ this.scale +') rotate('+this.rotate+'deg);top:0px;left:0px;';
				this.num++;
				this.imageUrl = this.imageList[this.num];
			}
		},
		// 缩小
		scaleOut() {
			this.scale = this.scale < 0.4 ? this.scale : this.scale - 0.2;
			this.style = 'transform: scale('+ this.scale +') rotate('+this.rotate+'deg);';
		},
		// 放大
		scaleIn() {
			this.scale = this.scale > 2 ? this.scale : this.scale + 0.2;
			this.style = 'transform: scale('+ this.scale +') rotate('+this.rotate+'deg);';
		},
		// 左转
		leftRotate() {
			this.rotate = this.rotate - 90;
			this.style = 'transform: scale('+ this.scale +') rotate('+this.rotate+'deg);';
		},
		// 右转
		rightRotate() {
			this.rotate = this.rotate + 90;
			this.style = 'transform: scale('+ this.scale +') rotate('+this.rotate+'deg);';
		},
		// 拖拽
		move(e){
            let odiv = e.target;        //获取目标元素
            //阻止默认事件的方法,如果不阻止默认事件onmouseup会无法触发
             e.preventDefault();
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft;
			let disY = e.clientY - odiv.offsetTop;
			let isoffsetLeft = odiv.offsetLeft;
            document.onmousemove = (e)=>{
				//鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
				//因为img居中对齐，所以还要减去目标元素距离body的偏移量

                let left = e.clientX - disX - isoffsetLeft;
                let top = e.clientY - disY;
                //移动当前元素
                odiv.style.left = left + 'px';
                odiv.style.top = top + 'px';
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        }
	}
}
</script>
<style lang="scss" scoped>
.viewer{
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	z-index: 100000;
}
.viewer-mask{
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	opacity: .5;
	background: #000;
}
.viewer-btn{
	position: absolute;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    opacity: .8;
    cursor: pointer;
    box-sizing: border-box;
    user-select: none;
}
.viewer-btn-close{
	top: 40px;
    right: 40px;
    width: 40px;
    height: 40px;
    font-size: 40px;
}
.viewer-btn-prev{
	top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    border-color: #fff;
	left: 40px;
}
.viewer-btn-next{
	top: 50%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    font-size: 24px;
    color: #fff;
    background-color: #606266;
    border-color: #fff;
	right: 40px;
    text-indent: 2px;
}
.viewer-btn-operation{
	left: 50%;
    bottom: 30px;
    transform: translateX(-50%);
    width: 180px;
    height: 44px;
    padding: 0 23px;
    background-color: #606266;
    border-color: #fff;
    border-radius: 22px;
}
.viewer-btn-inner{
	width: 100%;
    height: 100%;
    text-align: justify;
    cursor: default;
    font-size: 23px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.viewer-canvas{
	width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.viewer-image{
	position: relative;
	margin-left: 0px;
	margin-top: 0px;
	max-height:100%;
	max-width:100%;
}
.el-icon-zoom-out,
.el-icon-zoom-in,
.el-icon-refresh-left,
.el-icon-refresh-right{
	cursor: pointer;
}
.total{
	padding: 0 15px;
    font-size: 18px;
}
</style>
